/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_AdmissionInputs */

const en_verify_admission = /** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admission`)
};

const es_verify_admission = /** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admisión`)
};

const fr_verify_admission = /** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admission`)
};

const de_verify_admission = /** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einlass`)
};

const id_verify_admission = /** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintu Masuk`)
};

/** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */
const ja_verify_admission = en_verify_admission;

/** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */
const zh_verify_admission = en_verify_admission;

/** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */
const ar_verify_admission = en_verify_admission;

/** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */
const it_verify_admission = en_verify_admission;

/** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */
const ru_verify_admission = en_verify_admission;

/** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */
const pt_verify_admission = en_verify_admission;

/** @type {(inputs: Verify_AdmissionInputs) => LocalizedString} */
const ko_verify_admission = en_verify_admission;

/**
* | output |
* | --- |
* | "Admission" |
*
* @param {Verify_AdmissionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_admission = /** @type {((inputs?: Verify_AdmissionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_AdmissionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_admission(inputs)
	if (locale === "es") return es_verify_admission(inputs)
	if (locale === "fr") return fr_verify_admission(inputs)
	if (locale === "de") return de_verify_admission(inputs)
	if (locale === "ja") return ja_verify_admission(inputs)
	if (locale === "zh") return zh_verify_admission(inputs)
	if (locale === "ar") return ar_verify_admission(inputs)
	if (locale === "id") return id_verify_admission(inputs)
	if (locale === "it") return it_verify_admission(inputs)
	if (locale === "ru") return ru_verify_admission(inputs)
	if (locale === "pt") return pt_verify_admission(inputs)
	return ko_verify_admission(inputs)
});